import React, { useState } from 'react'
import {
  Container,
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Button
} from '@mui/material'
import {
  Add,
  List as ListIcon,
  TrendingUp
} from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import MovementForm from '../components/mrd/FileMovement/MovementForm'
import MovementList from '../components/mrd/FileMovement/MovementList'
import MovementDetail from '../components/mrd/FileMovement/MovementDetail'

export const FileMovementPage = () => {
  const navigate = useNavigate()
  
  const [tabValue, setTabValue] = useState(0)
  const [showForm, setShowForm] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)
  const [selectedMovement, setSelectedMovement] = useState(null)
  const [showDetail, setShowDetail] = useState(false)

  const handleMovementSuccess = (movement) => {
    setShowForm(false)
    setTabValue(1) // Switch to list tab
    setRefreshKey(prev => prev + 1)
  }

  const handleViewMovement = (movement) => {
    setSelectedMovement(movement)
    setShowDetail(true)
  }

  const handleCloseDetail = () => {
    setShowDetail(false)
    setSelectedMovement(null)
  }

  return (
    <Container maxWidth="xl">
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight={600} gutterBottom>
            File Movement
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Track and manage MRD file movements across departments
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => setShowForm(true)}
        >
          New Movement
        </Button>
      </Box>

      {showForm ? (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Create File Movement
          </Typography>
          <MovementForm
            onSuccess={handleMovementSuccess}
            onCancel={() => setShowForm(false)}
          />
        </Paper>
      ) : (
        <>
          <Paper sx={{ mb: 3 }}>
            <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)}>
              <Tab 
                label="All Movements" 
                icon={<ListIcon />}
                iconPosition="start"
              />
              <Tab 
                label="Pending Returns" 
                icon={<TrendingUp />}
                iconPosition="start"
              />
            </Tabs>
          </Paper>

          {tabValue === 0 && (
            <Paper sx={{ p: 3 }}>
              <MovementList 
                key={refreshKey}
                onEdit={(movement) => {
                  // Handle edit movement
                  console.log('Edit movement:', movement)
                }}
                onView={handleViewMovement}
              />
            </Paper>
          )}

          {tabValue === 1 && (
            <Paper sx={{ p: 3 }}>
              <MovementList 
                key={`pending-${refreshKey}`}
                statusFilter="DELIVERED"
                onEdit={(movement) => {
                  console.log('Edit movement:', movement)
                }}
                onView={handleViewMovement}
              />
            </Paper>
          )}
        </>
      )}

      {/* Movement Detail Dialog */}
      <MovementDetail
        open={showDetail}
        onClose={handleCloseDetail}
        movement={selectedMovement}
      />
    </Container>
  )
}

